// =============== SMOOTH SCROLL ===============
// const lenis = new Lenis({
//   autoRaf: true,
// });


// =============== LOAD MORE + CATEGORY FILTER FOR BLOG LIST PAGE ===============
document.addEventListener('DOMContentLoaded', function () {
  const blogContainer = document.querySelector('.blog-articles');
  const paginationWrapper = document.getElementById('pagination-wrapper');
  const loadMoreBtn = document.getElementById('load-more');
  const tabs = document.querySelectorAll('.blog-category-tab-button');

  if (!blogContainer) return;

  const perPage = parseInt(blogContainer.dataset.perPage || 9, 10);

  let selectedCategory = null;
  let currentPage = 1;

  function getFilteredArticles() {
    const articles = [...document.querySelectorAll('.blog-articles__article')];

    return articles.filter(article => {
      if (!selectedCategory) return true;

      const categories = (article.dataset.category || '')
        .split('|')
        .map(c => c.trim())
        .filter(Boolean);

      return categories.includes(selectedCategory);
    });
  }

  function renderArticles() {
    const allArticles = document.querySelectorAll('.blog-articles__article');

    allArticles.forEach(article => {
      article.style.display = 'none';
    });

    const filtered = getFilteredArticles();
    const visibleCount = currentPage * perPage;

    filtered.slice(0, visibleCount).forEach(article => {
      article.style.display = '';
    });

    if (loadMoreBtn) {
      loadMoreBtn.style.display =
        filtered.length > visibleCount ? '' : 'none';
    }

    if (paginationWrapper) {
      paginationWrapper.style.display =
        filtered.length > visibleCount ? '' : 'none';
    }
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      tabs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');

      const category = this.dataset.category;

      selectedCategory =
        category && category !== 'all' ? category : null;

      currentPage = 1;

      renderArticles();
    });
  });

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function () {
      currentPage++;
      renderArticles();
    });
  }

  renderArticles();
});


// =============== EVOLUTION-TIMELINE ===============
document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".timeline-item");

  function handleScroll() {
    const triggerBottom = window.innerHeight * 0.85;
    const screenCenter = window.innerHeight / 2;
    let closestItem = null;
    let closestDistance = Infinity;

    items.forEach((item) => {
      const rect = item.getBoundingClientRect();
      const itemCenter = rect.top + rect.height / 2;

      // Reveal effect
      if (rect.top < triggerBottom) {
        item.classList.add("active");
      }

      // Find closest item to screen center
      const distance = Math.abs(screenCenter - itemCenter);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestItem = item;
      }
    });

    // Highlight center-focused item
    items.forEach((i) => i.classList.remove("center-active"));
    if (closestItem) closestItem.classList.add("center-active");
  }

  window.addEventListener("scroll", handleScroll);
  handleScroll();
});


// =============== COLLECTION GRID VIEW ===============
document.querySelectorAll('.view-toggle button').forEach(button => {
  button.addEventListener('click', function () {
    const cols = this.dataset.columns;
    const grid = document.getElementById('product-grid');
    grid.className = `grid product-grid grid--${cols}-col-desktop`;

    // Toggle active state
    document.querySelectorAll('.view-toggle button').forEach(btn => btn.classList.remove('active'));
    this.classList.add('active');
  });
});
// COLLECTION GRID VIEW FOR < 630PX 
const gridElement = document.getElementById('product-grid');
const viewToggleContainer = document.querySelector('.view-toggle');
const toggleButtons = viewToggleContainer ? viewToggleContainer.querySelectorAll('button[data-columns]') : [];
const mediaQuery = window.matchMedia('(max-width: 630px)');
let currentGridPreference = 3;

function resetToggleActiveState() {
    toggleButtons.forEach(button => button.classList.remove('active'));
}

function updateGridClasses(columns) {
    const classesToRemove = [
        'grid--1-col-desktop', 
        'grid--2-col-desktop', 'grid--2-col-tablet-down', 
        'grid--3-col-desktop', 'grid--3-col-tablet-down', 
        'grid--4-col-desktop', 'grid--4-col-tablet-down'
    ];
    gridElement.classList.remove(...classesToRemove);

    switch (columns) {
        case 1:
            gridElement.classList.add('grid--1-col-desktop');
            break;
        case 2:
            gridElement.classList.add('grid--2-col-tablet-down', 'grid--2-col-desktop');
            break;
        case 3:
            gridElement.classList.add('grid--3-col-tablet-down', 'grid--3-col-desktop');
            break;
        case 4:
            gridElement.classList.add('grid--4-col-tablet-down', 'grid--4-col-desktop');
            break;
    }
}


function handleGridLayout(e) {
  if (!gridElement || !viewToggleContainer) return;

  if (e.matches) {
    resetToggleActiveState();
    
    if (currentGridPreference === 2) {
      updateGridClasses(2);
      viewToggleContainer.querySelector('button[data-columns="2"]').classList.add('active');
    } else {
      updateGridClasses(1);
      viewToggleContainer.querySelector('button[data-columns="1"]').classList.add('active');
    }
  } else {
    
    updateGridClasses(currentGridPreference);
    resetToggleActiveState();
    viewToggleContainer.querySelector(`button[data-columns="${currentGridPreference}"]`).classList.add('active');
  }
}

toggleButtons.forEach(button => {
    button.addEventListener('click', () => {
        const newColumns = parseInt(button.dataset.columns, 10);
        
        currentGridPreference = newColumns;
        
        updateGridClasses(newColumns);

        resetToggleActiveState();
        button.classList.add('active');
    });
});

mediaQuery.addListener(handleGridLayout);

handleGridLayout(mediaQuery);



//========== PLP PRICE RANGE FILTERS START ============//
document.addEventListener("DOMContentLoaded", function () {

    // price_range_filter();
  
  function price_range_filter() {
  const minRangeDesktop = document.getElementById("Desktop-Filter-price-range-min");
  const minRange = document.getElementById("Mobile-Filter-price-range-min");
    
  const maxRangeDesktop = document.getElementById("Desktop-Filter-price-range-max");
  const maxRange = document.getElementById("Mobile-Filter-price-range-max");
    
  // const minInput = document.getElementById("Mobile-Filter-Price-GTE");
  // const maxInput = document.getElementById("Mobile-Filter-Price-LTE");
  const minInput = document.querySelector(".price-input-min");
  const minInputMobile = document.querySelector(".mobile-price-input-min");

  const maxInput = document.querySelector(".price-input-max");
  const maxInputMobile = document.querySelector(".mobile-price-input-max");

  const rangeGroupDesktop = document.querySelector(".desktop-price-range-slider");
  const rangeGroup = document.querySelector(".price-range-slider");
  if(rangeGroupDesktop){
      if (rangeGroupDesktop.style.getPropertyValue("--range-min") == "0%" &&  rangeGroupDesktop.style.getPropertyValue("--range-max") == "100%"){
              if (document.getElementById("desktop-custom-reset-btn")) {                
                document.getElementById("desktop-custom-reset-btn").classList.add("reset-disabled");
              }
            }      
  }
    if(rangeGroup){
          if (rangeGroup.style.getPropertyValue("--range-min") == "0%" &&  rangeGroup.style.getPropertyValue("--range-max") == "100%"){
            if(document.getElementById("mobile-custom-reset-btn")){
              document.getElementById("mobile-custom-reset-btn").classList.add("reset-disabled");
            }
          }       
    }
    
    
  if (!minRange || !minRangeDesktop || !maxRange || !maxRangeDesktop || !minInput || !minInputMobile || !maxInput || !maxInputMobile || !rangeGroup) return;

  function updateRangeUI() {
      const minValue = parseInt(minRange.value);
      const minValueDesktop = parseInt(minRangeDesktop.value);
    
      const maxValue = parseInt(maxRange.value);
      const maxValueDesktop = parseInt(maxRangeDesktop.value);
    
      const minPercent = (minValue / parseInt(minRange.max)) * 100;
      const minPercentDesktop = (minValueDesktop / parseInt(minRangeDesktop.max)) * 100;
    
      const maxPercent = (maxValue / parseInt(maxRange.max)) * 100;
      const maxPercentDesktop = (maxValueDesktop / parseInt(maxRangeDesktop.max)) * 100;

      rangeGroup.style.setProperty("--range-min", `${minPercent}%`);
      rangeGroup.style.setProperty("--range-max", `${maxPercent}%`);
      rangeGroupDesktop.style.setProperty("--range-min", `${minPercentDesktop}%`);
      rangeGroupDesktop.style.setProperty("--range-max", `${maxPercentDesktop}%`);
    
      minInput.value = "€" + minValueDesktop + ".00";
      minInputMobile.value = "€" + minValue + ".00";
      maxInput.value = "€" + maxValueDesktop + ".00";
      maxInputMobile.value = "€" + maxValue + ".00";

        if (rangeGroupDesktop.style.getPropertyValue("--range-min") == "0%" &&  rangeGroupDesktop.style.getPropertyValue("--range-max") == "100%"){
          if(document.getElementById("desktop-custom-reset-btn")){
            document.getElementById("desktop-custom-reset-btn").classList.add("reset-disabled");
          }
        } else {
          if(document.getElementById("desktop-custom-reset-btn")){
          document.getElementById("desktop-custom-reset-btn").classList.remove("reset-disabled");
          }
        }
  
        if (rangeGroup.style.getPropertyValue("--range-min") == "0%" &&  rangeGroup.style.getPropertyValue("--range-max") == "100%"){
          if(document.getElementById("mobile-custom-reset-btn")){
            document.getElementById("mobile-custom-reset-btn").classList.add("reset-disabled");
          }
        } else {
          if(document.getElementById("mobile-custom-reset-btn")){
            document.getElementById("mobile-custom-reset-btn").classList.remove("reset-disabled");
          }
        }
    
  }

  function updateSliders() {
      minRange.value = minInput.value;
      minRange.value = minInputMobile.value;
    
      maxRange.value = maxInput.value;
      maxRange.value = maxInputMobile.value;
    
      updateRangeUI();
  }

  minRange.addEventListener("input", function () {
      if (parseInt(minRange.value) > parseInt(maxRange.value)) {
          minRange.value = maxRange.value;
      }
      updateRangeUI();
  });

  minRangeDesktop.addEventListener("input", function () {
      if (parseInt(minRangeDesktop.value) > parseInt(maxRangeDesktop.value)) {
          minRangeDesktop.value = maxRangeDesktop.value;
      }
      updateRangeUI();
  });

  maxRange.addEventListener("input", function () {
      if (parseInt(maxRange.value) < parseInt(minRange.value)) {
          maxRange.value = minRange.value;
      }
      updateRangeUI();
  });

  maxRangeDesktop.addEventListener("input", function () {
      if (parseInt(maxRangeDesktop.value) < parseInt(minRangeDesktop.value)) {
          maxRangeDesktop.value = minRangeDesktop.value;
      }
      updateRangeUI();
  });

  minInput.addEventListener("input", function () {
      if (parseInt(minInput.value) > parseInt(maxInput.value)) {
          minInput.value = maxInput.value;
      }
      updateSliders();
  });

  minInputMobile.addEventListener("input", function () {
      if (parseInt(minInputMobile.value) > parseInt(maxInputMobile.value)) {
          minInputMobile.value = maxInputMobile.value;
      }
      updateSliders();
  });

  maxInput.addEventListener("input", function () {
      if (parseInt(maxInput.value) < parseInt(minInput.value)) {
          maxInput.value = minInput.value;
      }
      updateSliders();
  });

  maxInputMobile.addEventListener("input", function () {
      if (parseInt(maxInputMobile.value) < parseInt(minInputMobile.value)) {
          maxInputMobile.value = minInputMobile.value;
      }
      updateSliders();
  });
  
      updateRangeUI(); // Initialize colors on load
  }
  
  price_range_filter();
  
})
//========== PLP PRICE RANGE FILTERS END ============//


//========== SALE FILTER START ===========//
// document.addEventListener('DOMContentLoaded', function() {
//     const saleCheckbox = document.getElementById('sale-only');
//     saleCheckbox.classList.add("activechek")
//     console.log(saleCheckbox,"saleCheckbox");
    

//     if (saleCheckbox) {
//       saleCheckbox.addEventListener('change', function() {
//         filterProductsOnSale(this.checked);
//       });
//     }

//     function filterProductsOnSale(showOnlySale) {
//       // 1. Find your product grid container
//       // COMMON SELECTORS: #product-grid, .collection-products, ul[id^="product-grid"]
//       const productGrid = document.getElementById('product-grid');
      
//       if (!productGrid) {
//         console.error('Could not find product grid container.');
//         return;
//       }

//       // 2. Find all product cards within that grid
//       // COMMON SELECTORS: .product-card, .grid__item, .collection-product-card
//       const productCards = productGrid.querySelectorAll('.product-card');

//       productCards.forEach(card => {
//         // 3. Find the element that shows a "sale" price or badge
//         // This is the most important part to get right for your theme.
//         // COMMON SELECTORS: .price--on-sale, .badge--on-sale, .sale-badge, .product-card__badge--sale
//         const saleIndicator = card.querySelector('.price--on-sale'); 

//         const isOnSale = (saleIndicator !== null);

//         if (showOnlySale) {
//           // If checkbox is checked, hide items that are NOT on sale
//           if (isOnSale) {
//             card.style.display = 'block'; // Or 'grid', 'flex', etc.
//           } else {
//             card.style.display = 'none';
//           }
//         } else {
//           // If checkbox is unchecked, show all items
//           card.style.display = 'block'; // Or 'grid', 'flex', etc.
//         }
//       });
//     }
//   });
//========== SALE FILTER END ===========//


//========== Swatch variant color ===========//
// document.querySelectorAll('.variant-swatch').forEach(swatch => {
//     swatch.addEventListener('click', function (e) {
//         e.preventDefault();

//         // Remove old active state
//         document.querySelectorAll('.variant-swatch')
//             .forEach(s => s.classList.remove('active-swatch'));

//         // Add active class to current swatch
//         this.classList.add('active-swatch');

//         // Get new image from data attribute
//         const newImg = this.getAttribute('data-variant-image');

//         // 1. Find parent .card__content
//         const cardContent = this.closest('.card__content');

//         if (!cardContent) return;

//         // 2. Find previous sibling .card__inner
//         const cardInner = cardContent.previousElementSibling;

//         if (!cardInner || !cardInner.classList.contains('card__inner')) return;

//         // 3. Find the target image inside:
//         // .card__media → .custom-media-div → img
//         const targetImg = cardInner.querySelector('.card__media .custom-media-div img');

//         if (targetImg) {
//             targetImg.src = newImg;
//             targetImg.srcset = "";

//         }
//     });
// });

// function initVariantSwatches() {
//     const swatches = document.querySelectorAll('.variant-swatch');

//     swatches.forEach(swatch => {
//         swatch.addEventListener('click', function (e) {
//             e.preventDefault();

//             // Remove old active state
//             document.querySelectorAll('.variant-swatch')
//                 .forEach(s => s.classList.remove('active-swatch'));

//             // Add active class to current swatch
//             this.classList.add('active-swatch');

//             // Get new image from data attribute
//             const newImg = this.getAttribute('data-variant-image');

//             // 1. Find parent .card__content
//             const cardContent = this.closest('.card__content');
//             if (!cardContent) return;

//             // 2. Find previous sibling .card__inner
//             const cardInner = cardContent.previousElementSibling;
//             if (!cardInner || !cardInner.classList.contains('card__inner')) return;

//             // 3. Find target image
//             const targetImg = cardInner.querySelector('.card__media .custom-media-div img');

//             if (targetImg) {
//                 targetImg.src = newImg;
//                 targetImg.srcset = "";
//             }
//         });
//     });
// }
function initVariantSwatches() {
    const swatches = document.querySelectorAll('.variant-swatch');

    swatches.forEach(swatch => {
        swatch.addEventListener('click', function (e) {
            e.preventDefault();

            // ---------------------------
            // 1. ACTIVE CLASS HANDLING
            // ---------------------------
            const cardContent = this.closest('.card__content');
            cardContent.querySelectorAll('.variant-swatch')
                .forEach(s => s.classList.remove('active-swatch'));

            this.classList.add('active-swatch');

            // ---------------------------
            // 2. UPDATE IMAGE
            // ---------------------------
            const newImg = this.dataset.variantImage;

            const cardInner = cardContent.previousElementSibling;
            const targetImg = cardInner?.querySelector('.card__media .custom-media-div img');

            if (targetImg) {
                targetImg.src = newImg;
                targetImg.srcset = "";
            }

            // ---------------------------
            // 3. GET PRICES
            // ---------------------------
            const salePrice = (this.dataset.salePrice || "").trim();
            const comparePrice = (this.dataset.comparePrice || "").trim();

            const cardInfo = cardContent.querySelector('.card-information');
            if (!cardInfo) return;

            const priceWrapper = cardInfo.querySelector('.price');
            const regularPriceEl = cardInfo.querySelector('.price-item--regular');
            const salePriceEl = cardInfo.querySelector('.price-item--sale');

            // ---------------------------
            // 4. PRICE UPDATE LOGIC
            // ---------------------------

            // CASE 1: ON SALE (both prices exist)
            if (salePrice !== "" && comparePrice !== "") {
                priceWrapper.classList.add('price--on-sale');

                if (regularPriceEl) {
                    regularPriceEl.textContent = comparePrice;
                    regularPriceEl.style.textDecoration = "line-through";
                    regularPriceEl.style.color = "#b0b0b0";
                }

                if (salePriceEl) {
                    salePriceEl.textContent = "From " + salePrice;
                    salePriceEl.classList.remove("hidden");
                }

                return;
            }

            // CASE 2: NOT ON SALE (sale is empty, compare exists)
            if (salePrice === "" && comparePrice !== "") {
                priceWrapper.classList.remove('price--on-sale');

                if (regularPriceEl) {
                    regularPriceEl.textContent = comparePrice;
                    regularPriceEl.style.textDecoration = "none";
                    regularPriceEl.style.color = "#000";
                }

                if (salePriceEl) {
                    salePriceEl.classList.add("hidden");
                }

                return;
            }

            // CASE 3: No prices → do nothing
        });
    });
}

window.addEventListener('load', initVariantSwatches);

